import React, {MutableRefObject, useCallback, useMemo, useState} from 'react'

import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext'
import {
    LexicalTypeaheadMenuPlugin,
    useBasicTypeaheadTriggerMatch,
} from '@lexical/react/LexicalTypeaheadMenuPlugin'
import {$createTextNode, TextNode} from 'lexical'

import {$createMentionNode} from "./node/node"
import {searchMentions} from "./functions/search-mention"
import {getPossibleQueryMatch} from "./functions/get-possible-query-match"
import {MentionOption} from "./option"
import {MentionsMenu} from "./menu"
import {EntitySelectorSettings} from "../../editor"

type Props = {
    entitySelectorSettings  : EntitySelectorSettings
    mentions?               : any
    projectId?              : ID
}

const debug = false
// const debug = "MentionsPlugin"

export default function MentionsPlugin(props: Props): JSX.Element | null {
    const [editor]                      = useLexicalComposerContext()

    debug && console.log(debug, 'render results', props.mentions)

    const checkForSlashTriggerMatch = useBasicTypeaheadTriggerMatch('/', {
        minLength: 0,
    })

    const onSelectOption = useCallback(
        (
            selectedOption  : MentionOption,
            nodeToReplace   : TextNode | null,
            closeMenu       : () => void,
        ) => {
            editor.update(() => {
                const mentionNode = $createMentionNode(selectedOption)
                if (nodeToReplace) {
                    nodeToReplace.replace(mentionNode)
                    mentionNode.insertAfter($createTextNode(' '))
                }
                closeMenu()
            })
        },
        [editor],
    )

    const checkForMentionMatch = useCallback(
        (text: string) => {
            const slashMatch = checkForSlashTriggerMatch(text, editor)
            if (slashMatch !== null) return null
            return getPossibleQueryMatch(text)
        },
        [checkForSlashTriggerMatch, editor],
    )

    debug && console.log(debug, 'render', props.entitySelectorSettings)

    return (
        <LexicalTypeaheadMenuPlugin<MentionOption> onQueryChange    = {()=>{}}
                                                   onSelectOption   = {onSelectOption}
                                                   triggerFn        = {checkForMentionMatch}
                                                   options          = {[]}
                                                   menuRenderFn     = {(
                                                       anchorElementRef    : MutableRefObject<HTMLElement | null>,
                                                       itemProps           : {
                                                           selectedIndex           : number | null
                                                           selectOptionAndCleanUp  : (option: MentionOption) => void
                                                           setHighlightedIndex     : (index: number) => void
                                                           options                 : Array<MentionOption>
                                                       },
                                                       matchingString      : string | null
                                                   )=>{
                                                       return MentionsMenu(anchorElementRef, itemProps, matchingString, props.mentions, props.projectId, props.entitySelectorSettings)
                                                   }}/>
    )
}
